import usePetState from '~/shared/apis/usePetState.hook'

export function useGetBaseSrcKey(): string {
  const [petState] = usePetState()
  const ifDragon = petState?.eggChosen !== 'blue' ? 'dragon-v2' : 'dragon'
  const ifEgg = petState?.eggChosen ? 'egg' : 'egg-v2'
  const color = petState?.eggChosen ? petState.eggChosen : 'default'

  const url = `gamification/base-${color}-${petState?.stillHatching ? ifEgg : ifDragon}.png`

  return url
}

export function useGetSpaceSrcKey(): string {
  const [petState] = usePetState()
  const color = petState?.eggChosen ? petState.eggChosen : 'default-v2'
  const url = `gamification/${color}-${petState?.stillHatching ? 'egg' : 'dragon'}.png`

  return url
}
